import './calculationGridComponent.scss';


class CalculationsGridComponent {

    constructor($scope, $log) {
        this.$scope = $scope;
        this.$log = $log;
        this.$log.debug('Calculations grid component is mounting');
    }

    $onInit = () => {
        this.$log.debug('Calculations grid component has mounted');
        this.$scope.calculations = this.calculations;
    }
}

const CALCULATIONS_GRID_CONTROLLER = ['$scope', '$log', CalculationsGridComponent];

export const CALCULATIONS_GRID_COMPONENT = {
    template: require('./calcualtionsGridComponent.html'),
    controller: CALCULATIONS_GRID_CONTROLLER,
    bindings: {
        calculations: '<'
    }
};